export default __webpack_public_path__ + "static/media/Marker.1dbefbe8.svg";